__webpack_require__.f.compat = (chunkId, promises) => {
	var Promise = __webpack_require__(3641);
};